// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-select-auto-complete.ant-select .ant-input[disabled] {
    color: black;
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 1;
    background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/Doctor/doctor.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,6BAA6B;AACjC","sourcesContent":[".ant-select-auto-complete.ant-select .ant-input[disabled] {\r\n    color: black;\r\n    background-color: #f5f5f5;\r\n    cursor: not-allowed;\r\n    opacity: 1;\r\n    background-color: transparent;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
